import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import Layout from '../views/controlCenter/layout/layout'

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home', // 首页
      redirect: '/home'
    },
    {
      path: '/home',
      name: 'HomeIndex', // 首页
      component: () => import('@/views/home/index')
    },
    {
      path: '/regist',
      name: 'AccountRegist', // 注册账号
      component: () => import('@/views/account/regist')
    },
    {
      path: '/forgot',
      name: 'AccountForgot', // 忘记密码
      component: () => import('@/views/account/forgot')
    },
    {
      path: '/document',
      name: 'DocumentIndex', // 文档中心
      component: () => import('@/views/document/index')
    },
    {
      path: '/ST/apply',
      name: 'STApply', // ST板卡申请
      component: () => import('@/views/other/apply')
    },
    {
	    path: '/control',
	    component: Layout,
	    redirect: '/dashboard',
	    name: 'Control', //控制中心
	    children: [
        {
  	      path: 'dashboard',
          name: 'DashboardPreview',
  		    component: () => import('@/views/controlCenter/dashboard/index'),
  	    },
        {
          path: 'device',
          redirect: '/device/device',
          component:() => import('@/views/controlCenter/deviceManage/base'),
          name: 'DeviceManage',
          children: [
            {
              path: '/',
              name: 'Device',
              redirect: '/device/device',
              component: () => import('@/views/controlCenter/deviceManage/device/base'),
              children: [
                {
                  path: 'index',
                  name: 'DeviceList',
                  component: () => import('@/views/controlCenter/deviceManage/device/list'),
                },
                {
                  path: 'detail/:id',
                  name: 'DeviceDetail',
                  component: () => import('@/views/controlCenter/deviceManage/device/detail/detail'),
                },
              ]
            },{
              path: '/',
              name: 'Group',
              redirect: '/group',
              component: () => import('@/views/controlCenter/deviceManage/group/base'),
              children: [
                {
                  path: 'group',
                  name: 'GroupList',
                  component: () => import('@/views/controlCenter/deviceManage/group/list'),
                },
                {
                  path: 'group/detail/:id',
                  name: 'GroupDetail',
                  component: () => import('@/views/controlCenter/deviceManage/group/detail/detail'),
                },
              ]
            },{
              path: '/',
              name: 'Task',
              redirect: '/task',
              component: () => import('@/views/controlCenter/deviceManage/task/base'),
              children: [
                {
                  path: 'task',
                  name: 'TaskList',
                  component: () => import('@/views/controlCenter/deviceManage/task/list'),
                },
                {
                  path: 'task/create',
                  name: 'TaskCreate',
                  component: () => import('@/views/controlCenter/deviceManage/task/create'),
                },
                {
                  path: 'task/detail/:id',
                  name: 'TaskDetail',
                  component: () => import('@/views/controlCenter/deviceManage/task/detail/detail'),
                },
              ]
            }
          ]
        },
        {
          path: '/',
          name: 'CertManage',
          redirect: '/cert',
          component: () => import('@/views/controlCenter/certManage/base'),
          children: [
            {
              path: 'cert',
              name: 'CertList',
              component: () => import('@/views/controlCenter/certManage/list'),
            },
            {
              path: 'cert/detail',
              name: 'CertDetail',
              component: () => import('@/views/controlCenter/certManage/detail'),
            },
          ]
        },
        {
          path: '/',
          name: 'AppManage',
          redirect: '/app',
          component: () => import('@/views/controlCenter/appManage/base'),
          children: [
            {
              path: 'app',
              name: 'AppList',
              component: () => import('@/views/controlCenter/appManage/list'),
            },
            {
              path: 'app/detail/:id',
              name: 'AppDetail',
              component: () => import('@/views/controlCenter/appManage/detail'),
            },
          ]
        },
        {
          path: 'user',
          name: 'User',
          component: () => import('@/views/controlCenter/user/index'),
        },
        {
          path: 'server',
          name: 'Server',
          redirect: '/server/audio',
          component: () => import('@/views/controlCenter/server/base'),
          children: [
            {
              path: 'audio',
              name: 'ServerAudio',
              component: () => import('@/views/controlCenter/server/audio/index'),
            }
          ]
        }
      ]
		},
    { path: '/404', component: () => import('@/views/404'), hidden: true },
    { path: '*', redirect: '/404', hidden: true }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js